module.exports = __webpack_public_path__ + "static/morph-214e845ed69070d23ada525c39bd34cd.jpg";